import { render } from "./Demo.vue?vue&type=template&id=1b5641b0"
const script = {}

import "./Demo.vue?vue&type=style&index=0&id=1b5641b0&lang=scss"

import exportComponent from "/var/www/patternmaking/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__